export default "__VITE_ASSET__B7vRJm1v__"